import { gql, TypedDocumentNode } from '@apollo/client';

import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
export type GetCurrentMonthExchangeVolumeRes = {
  amount: number;
  id: string;
};
export type GetCurrentMonthExchangeVolumeResponse = {
  getCurrentMonthExchangeVolume: DefaultApiResponse<GetCurrentMonthExchangeVolumeRes>;
};

export const getCurrentMonthExchangeVolumeQuery: TypedDocumentNode<
  GetCurrentMonthExchangeVolumeResponse,
  DefaultArg<{ valueAssetCode: string }>
> = gql`
  query GetCurrentMonthExchangeVolume(
    $record: GetCurrentMonthExchangeVolumeRecord!
  ) {
    getCurrentMonthExchangeVolume(record: $record) {
      amount
      id
    }
  }
`;
